export default {
  UPLOAD_SUPPORTERS_REQUEST: 'UPLOAD_SUPPORTERS_REQUEST',
  UPLOAD_SUPPORTERS_FAILED: 'UPLOAD_SUPPORTERS_FAILED',
  UPLOAD_SUPPORTERS_SUCCESS: 'UPLOAD_SUPPORTERS_FAILED',

  FETCH_EMPLOYEES_REQUEST: 'FETCH_EMPLOYEES_REQUEST',
  FETCH_EMPLOYEES_FAILED: 'FETCH_EMPLOYEES_FAILED',
  FETCH_EMPLOYEES_SUCCESS: 'FETCH_EMPLOYEES_SUCCESS',

  FETCH_WELCOME_REQUEST: 'FETCH_WELCOME_REQUEST',
  FETCH_WELCOME_FAILED: 'FETCH_WELCOME_FAILED',
  FETCH_WELCOME_SUCCESS: 'FETCH_WELCOME_SUCCESS',

  DELETE_EMPLOYEES_REQUEST: 'DELETE_EMPLOYEES_REQUEST',
  DELETE_EMPLOYEES_FAILED: 'DELETE_EMPLOYEES_FAILED',
  DELETE_EMPLOYEES_SUCCESS: 'DELETE_EMPLOYEES_SUCCESS',
  // SIGNUP_REQUEST: "SIGNUP_REQUEST",
  // SIGNUP_FAILED: "SIGNUP_FAILED",
  // SIGNUP_SUCCESS: "SIGNUP_SUCCESS",

  // LOGIN_REQUEST: "LOGIN_REQUEST",
  // LOGIN_FAILED: "LOGIN_FAILED",
  // LOGIN_SUCCESS: "LOGIN_SUCCESS",

  // FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  // FORGOT_PASSWORD_FAILED: "FORGOT_PASSWORD_FAILED",
  // FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",

  FETCH_manager_REQUEST: 'FETCH_manager_REQUEST',
  FETCH_manager_FAILED: 'FETCH_manager_FAILED',
  FETCH_manager_SUCCESS: 'FETCH_manager_SUCCESS',

  DELETE_manager_REQUEST: 'DELETE_manager_REQUEST',
  DELETE_manager_FAILED: 'DELETE_manager_FAILED',
  DELETE_manager_SUCCESS: 'DELETE_manager_SUCCESS'
};
